<template>
<div>
    <div v-if="kunciSpmk">
        <div style="width:100%; height:100%; background-color:#00000024; position: absolute; z-index:2;top:0">
            <v-icon style="color:#0000001f;margin-top:10px;font-size:100px;">lock</v-icon>
        </div>
    </div>
    <v-form ref="form" lazy-validation>
        <v-container>
            
            <!-- SPK -->
            <template v-if="spk">
                <v-row>
                    <v-col cols="3" class="yellow lighten-4 font-weight-bold">Tanggal Penandatanganan Kontrak</v-col>
                    <v-col cols="4"> <text-field-date-picker :date-value="getDateFormattedDatefns(form.tglKontrak)" @changed="form.tglKontrak = $event"  :rules="[rules.required]" /> </v-col> 
                </v-row>
                <v-row>
                    <v-col cols="3" class="yellow lighten-4 font-weight-bold">Lama Pekerjaan</v-col>
                    <v-col cols="2"> <v-text-field v-model="form.lamaPekerjaan" type="number" suffix="hari"  :rules="[rules.required, validateHari()]" /> </v-col> 
                    <v-col cols="3"> <v-select v-model="form.jenisHari" label="Jenis Hari" :items="[ {text: 'Hari Kalender', value: 'K'}, {text: 'Hari Kerja', value: 'R'} ]"  /> </v-col>
                </v-row>
                <v-row>
                    <v-col cols="3" class="yellow lighten-4 font-weight-bold">Nilai Kontrak</v-col>
                    <v-col cols="2"> <text-field-rupiah v-model="form.nilaiKontrak"  :rules="[rules.required]" /> </v-col> 
                </v-row>
            </template>

            <!-- SPMK -->
            <template v-if="spmk">
                
                <v-row>
                    <v-col cols="3" class="yellow lighten-4 font-weight-bold">Tanggal Mulai Kontrak</v-col>
                    <v-col cols="4"> <text-field-date-picker :date-value="getDateFormattedDatefns(form.mulaiKontrak)" @changed="updateTglSelesaiKontrak($event)"  :rules="[rules.required]" /> </v-col> 
                </v-row>
                <v-row>
                    <v-col cols="3" class="yellow lighten-4 font-weight-bold">Tanggal Selesai Kontrak</v-col>
                    <v-col cols="4"> <text-field-date-picker :date-value="getDateFormattedDatefns(form.selesaiKontrak)" @changed="form.selesaiKontrak = $event"  :rules="[rules.required, validateTanggalSelesaiKontrak()]" /> </v-col> 
                </v-row>
            </template>

            <v-row>         
                <v-col cols="3" class="yellow lighten-4 font-weight-bold"></v-col>   
                <v-col> <v-btn color="green" dark @click="submit()">Simpan</v-btn> </v-col>   
                <v-col> <v-btn  color="cyan" dark @click="selesaiSpmk()">SPMK Selesai</v-btn> </v-col>   
                <!-- <v-col> <v-btn v-if="!readonly && spmk" color="cyan" dark @click="showConfirmation = true">Tender Selesai</v-btn> </v-col>  -->
            </v-row>
        </v-container>
    </v-form>
    
    <v-divider />

    <!-- <v-dialog v-model="showConfirmation" max-width="500px" persistent>  
        <v-card dark>
            <v-card-title>Anda yakin ingin menyelesaikan proses tender?</v-card-title>
            <v-divider />
            <v-card-actions>
                <v-btn color="success" dark @click="submitTenderSelesai()">Selesai</v-btn>
                <v-btn color="orange" dark @click="showConfirmation = false">Batal</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog> -->

    <!-- Notification -->
    <v-snackbar v-model="notification.show" :color="notification.color" :timeout="3000" top right>
        {{notification.text}}
    </v-snackbar>

    <v-dialog v-model="submitting" persistent max-width="300px">
        <v-card dark>
            <v-card-title>Sedang diproses</v-card-title>
            <v-card-text> <v-progress-linear color="cyan" indeterminate /> </v-card-text>
        </v-card>
    </v-dialog>

</div>
</template>


<script>

const axios = require('axios').default;
const apiUrl = process.env.VUE_APP_ROOT_API

import { format } from 'date-fns';
import { rules } from './../../lib/rules';
import TextFieldDatePicker from "./../../components/TextFieldDatePicker";
import TextFieldRupiah from "./../TextFieldRupiah.vue";


export default {
    components: {
        "text-field-date-picker": TextFieldDatePicker,
        "text-field-rupiah": TextFieldRupiah
    },

    props: {
        spk: {
            type: Boolean,
            default: false
        },
        spmk: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            rules: { required: rules.required },

            form: {
                paketPenyediaId: null,
                lamaPekerjaan: 0,
                jenisHari: 'K',
                tglKontrak: null,
                mulaiKontrak: null,
                selesaiKontrak: null,
                nilaiKontrak: 0,
            },

            showConfirmation: false,

            notification: {
                show: false,
                color: "success",
                text: ""
            },

            submitting: false,
            kunciSpmk: false
        }

    }, // data    

    computed: {
        paket: function() {
            return this.$store.getters['lelang/paket'];
        },
    },

    watch: {
        paket() {
            this.getData();
        }
    },

    mounted() {
        this.getData();
    },

    methods: {
        getData() {
            this.form.paketPenyediaId = this.paket.id;
            this.form.lamaPekerjaan = (this.paket.lamaPekerjaan == null || this.paket.lamaPekerjaan <= 0) ? 14 : this.paket.lamaPekerjaan;
            this.form.jenisHari = this.paket.jenisHari;
            this.form.tglKontrak = this.paket.tglKontrak;
            this.form.mulaiKontrak = this.paket.mulaiKontrak;
            this.form.selesaiKontrak = this.paket.selesaiKontrak;   
            this.form.nilaiKontrak = this.paket.nilaiKontrak;
            this.kunciSpmk = this.paket.kunciSpmk;

            //this.updateTglSelesaiKontrak(this.form.lamaPekerjaan);
        },

        getDateFormattedDatefns(date) {
            // console.log(`tgl yg masuk: ${date}`)
            return date ? format(Date.parse(date), "dd MMM yyyy") : ''
        },

        updateTglSelesaiKontrak(value) {
            if (value == null || value === "") return;
            //console.log("SuratPerjanjian:updateTglSelesaiKontrak()", value);
            this.form.mulaiKontrak = value;
            let endDate = new Date(value);
            endDate.setTime(endDate.getTime() + (24 * 60 * 60 * 1000) * this.form.lamaPekerjaan);
            this.form.selesaiKontrak = endDate;
        },

        /*
        updateLamaPekerjaan(value) {
            this.form.selesaiKontrak = value;
            const startDate = new Date(this.form.mulaiKontrak);
            const endDate = new Date(this.form.selesaiKontrak);
            this.form.lamaPekerjaan = (endDate.getTime() - startDate.getTime()) / (24 * 60 * 60 * 1000);
        },

        validateTanggalMulaiKontrak() {
            const startDate = new Date(this.form.tglKontrak);
            const endDate = new Date(this.form.mulaiKontrak);
            return startDate < endDate || "Tanggal penandatanganan kontrak tidak boleh melebihi tanggal mulai kontrak";
        },
        */

        validateTanggalSelesaiKontrak() {
            const startDate = new Date(this.form.mulaiKontrak);
            const endDate = new Date(this.form.selesaiKontrak);
            return startDate < endDate || `Tanggal selesai kontrak tidak boleh sama atau mendahului tanggal mulai kontrak`;
        },

        validateHari() {
            return this.form.lamaPekerjaan > 0 || "Lama pekerjaan tidah boleh lebih kecil atau sama dengan 0 (nol)";
        },

        submit() {
            if (!this.$refs.form.validate()) return;

            console.log("SuratPerjanjian:submit() ", this.form);
            this.submitting = true;

            axios.put(`${apiUrl}/api/lelang/surat-perjanjian`, this.form)
            .then( () => {
                this.notification = {
                    show: true,
                    color: "success",
                    text: "Form surat berhasil disimpan"
                };

            }).catch( (error) => {
                console.error(error);

                this.notification = {
                    show: true,
                    color: "error",
                    text: `Gagal simpan form surat [${error.message}]`
                };
            })
            .finally( () => {
                this.submitting = false;
            })
            
        },

        submitTenderSelesai() {
            axios.put(`${apiUrl}/api/rup/lelang/selesai/${this.paket.id}`)
            .then( () => {
                this.notification = {
                    show: true,
                    color: "success",
                    text: "Proses tender telah selesai"
                };

                this.showConfirmation = false;
            })
            .catch( (error) => {
                console.error(error);
                this.notification = {
                    show: true,
                    color: "error",
                    text: `Gagal update proses penyelesaian tender [${error.message}]`
                }
            });
        },
         selesaiSpmk() {
            axios.put(`${apiUrl}/api/rup/lelang/selesai-smpk/${this.paket.id}`)
            .then( (response) => {
                this.kunciSpmk = response.data.kunciSpmk;
                this.notification = {
                    show: true,
                    color: "success",
                    text: "Proses smpk telah selesai"
                };

                this.showConfirmation = false;
            })
            .catch( (error) => {
                console.error(error);
                this.notification = {
                    show: true,
                    color: "error",
                    text: `Gagal update proses penyelesaian smpk [${error.message}]`
                }
            });
        },
    }
}

</script>
